
import { Annotation } from '../../../types/annotation';
import { AnnotationItem } from './AnnotationItem';

interface AnnotationListProps {
  annotations: Annotation[];
  onAnnotationClick: (id: string) => void;
  activeAnnotationId: string | null;
}

export function AnnotationList({ 
  annotations, 
  onAnnotationClick,
  activeAnnotationId 
}: AnnotationListProps) {
  return (
    <div className="tw-bg-card tw-border tw-rounded-lg tw-p-4 tw-h-[calc(100vh-8rem)] tw-overflow-y-auto tw-sticky tw-top-4">
      <h2 className="tw-text-lg tw-font-semibold tw-mb-4">Annotations</h2>
      {annotations.length > 0 ? (
        <div className="tw-space-y-2">
          {annotations.map(annotation => (
            <AnnotationItem
              key={annotation.id}
              annotation={annotation}
              onClick={onAnnotationClick}
              isActive={annotation.id === activeAnnotationId}
            />
          ))}
        </div>
      ) : (
        <div className="tw-text-center tw-text-muted-foreground tw-p-8">
          <p>No annotations yet</p>
          <p className="tw-text-sm tw-mt-2">Press 'A' to add your first annotation</p>
        </div>
      )}
    </div>
  );
}